import { createSlice } from "@reduxjs/toolkit";

import { INITIAL_REPLIES } from "utils";
import { getUrlParam } from "utils/methods/index";
import { FORM_4_CONTACT_US_REPLIES } from "utils/constants/index";

const contactOnly = getUrlParam("page") == "contact-me";

const initialState = {
  replies: contactOnly ? FORM_4_CONTACT_US_REPLIES : INITIAL_REPLIES,
  optionsTypeLogs: [],
  isPerformanceReport: false,
  amaReply: null,
  isFetchManagement: true,
  amaResponse: null,
};

export const repliesSlice = createSlice({
  name: "replies",
  initialState,
  reducers: {
    setReplies: (state, action) => {
      state.replies = action.payload;
    },
    setIsPerformanceReport: (state, action) => {
      state.isPerformanceReport = action.payload;
    },
    setOptionsTypeLogs: (state, action) => {
      state.optionsTypeLogs = action.payload;
    },
    setAMAReply: (state, action) => {
      state.amaReply = action.payload;
    },
    setIsFetchManagement: (state, action) => {
      state.isFetchManagement = action.payload;
    },
    setAMAResponse: (state, action) => {
      state.amaResponse = action.payload;
    },
  },
});

export const selectReplies = (state) => state.replies.replies;
export const getAMAReply = (state) => state.replies.amaReply;
export const selectOptionsTypeLogs = (state) => state.replies.optionsTypeLogs;
export const selectIsFetchManagement = (state) => state.replies.isFetchManagement;
export const selectPerformanceReport = (state) => state.replies.isPerformanceReport;
export const selectAMAResponse = (state) => state.replies.amaResponse;

export const { setReplies, setAMAReply, setOptionsTypeLogs, setIsPerformanceReport, setIsFetchManagement, setAMAResponse } = repliesSlice.actions;

export default repliesSlice.reducer;
